export default "__VITE_ASSET__DXWorMAV__"